import TicketQr from '@components/modals/TicketQr';
import { Icon, IconButton, Typography } from '@elements';
import QRIconDisabled from '@images/qr-icon-disabled.svg';
import QRIcon from '@images/qr-icon.svg';
import { Box } from '@mui/material';
import { CATEGORY_TYPE } from '@types';
import React from 'react';

type Props = {
  sector_prefix: string;
  sector: string;
  line_prefix: string;
  line: string;
  seat_prefix: string;
  seat: string;
  date: string;
  time: string;
  price: number;
  barcode: string | null;
  disabled?: boolean;
  categoryType?: CATEGORY_TYPE;
};

const Details = ({
  sector_prefix,
  sector,
  line_prefix,
  line,
  seat_prefix,
  seat,
  date,
  time,
  price,
  disabled,
  barcode,
  categoryType,
}: Props) => {
  const [qrCodeOpen, setQrCodeOpen] = React.useState(false);

  const handleClickOpen = () => {
    setQrCodeOpen(true);
  };

  const handleClose = () => {
    setQrCodeOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
        <Typography color="silver">Дата</Typography>
        <Typography color="blackSecondary">{date}</Typography>
        <Typography color="silver">Время</Typography>
        <Typography color="blackSecondary">{time}</Typography>
        {categoryType === CATEGORY_TYPE.CHILD && (
          <Typography sx={{ mt: '-10px' }} color="internationalOrange">
            Детский билет
          </Typography>
        )}
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
        <Typography color="silver" textAlign="center">
          Место
        </Typography>
        <Typography color="blackSecondary" textAlign="center">
          {sector_prefix} {sector}
        </Typography>
        <Typography color="blackSecondary" textAlign="center">
          {line_prefix} {line}
        </Typography>
        <Typography color="blackSecondary" textAlign="center">
          {seat_prefix} {seat}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
        <Typography color="silver" textAlign="end">
          Стоимость
        </Typography>
        <Typography color="blackSecondary" textAlign="center">
          {price} ₽
        </Typography>
        <IconButton disabled={disabled} onClick={handleClickOpen}>
          <Icon
            src={disabled ? QRIconDisabled : QRIcon}
            width={40}
            height={40}
          />
        </IconButton>
      </Box>

      <TicketQr
        isOpen={qrCodeOpen}
        handleClose={handleClose}
        barcode={barcode}
        sector_prefix={sector_prefix}
        sector={sector}
        line_prefix={line_prefix}
        line={line}
        seat_prefix={seat_prefix}
        seat={seat}
      />
    </Box>
  );
};

export default Details;
